import { useLocation } from 'react-router-dom'
import { useEffect, useRef, memo } from 'react'

interface PageTransitionProps {
  children: React.ReactNode
}

export const PageTransition = memo(function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation()
  const containerRef = useRef<HTMLDivElement>(null)
  
  // Only animate on top-level route changes (e.g., /video, /assets)
  // Not on nested routes (e.g., /video/t2v -> /video/i2v)
  const topLevelPath = '/' + (location.pathname.split('/')[1] || '')

  // Reset scroll position on route change
  useEffect(() => {
    // Find the scrollable main container and reset its scroll
    const main = containerRef.current?.closest('main')
    if (main) {
      main.scrollTo(0, 0)
    }
  }, [location.pathname])

  return (
    <div
      ref={containerRef}
      key={topLevelPath}
      className="min-h-full animate-page-in"
    >
      {children}
    </div>
  )
})
